import React, { useEffect, useState } from "react";
import {
  Layout,
  Row,
  Col,
  Menu,
  Image,
  Typography,
  Divider,
  Tabs,
  Button,
  Card,
} from "antd";
import { mockData } from "./mock";
import styles from "./MarketPlace.module.scss";
import Percent from "@assets/KPMG/percent.svg";
import Rating from "@assets/KPMG/rating.svg";
import MarketPlaceImg from "@assets/KPMG/MarketPlace.png";
import Location from "@assets/KPMG/location.svg";
import { Fade } from "react-awesome-reveal";
import MarketingCard from "~/Components/MarketingCard/MarketingCard";
import { useNavigate } from "react-router-dom";
import { ProjectsCard } from "~/Components/ProjectsCard/ProjectsCard";
import { InvestmentHubData } from "~/mocks/MockData";

interface Props {
  data: any;
}

export const TabInfo = ({ data }: Props) => {
  const [selectedContent, setSelectedContent] = useState<any>({});
  const navigate = useNavigate();

  useEffect(() => {
    setSelectedContent(InvestmentHubData);
  }, []);

  return (
    <>
      {/* <div className="tab-info" style={{ display: "flex", paddingTop: 20 }}>
      </div> */}
      {data && (
        <div className="projectList">
          <Fade direction="left" triggerOnce>
            <div>
              <Row gutter={[32, 32]} style={{ marginTop: 20 }}>
                <Col span={12}>
                  <div>
                    <Typography.Text className="text" style={{ color: styles.white }}>
                      {data.description}
                    </Typography.Text>
                    <div style={{ marginTop: 40 }}>
                      <Image src={data.image} preview={false} />
                    </div>
                  </div>
                </Col>
                <Col span={12}>
                  <Row gutter={[32, 32]}>
                    {data &&
                      data.projects &&
                      data.projects.map((item: any, index: number) => (
                        <Col
                          md={24}
                          sm={24}
                          key={index}
                          style={{ display: index <= 1 ? "block" : "none" }}
                        >
                          <MarketingCard item={item} index={index} />
                        </Col>
                      ))}
                    <Col span={24}>
                      <div style={{ padding: "0px 0" }}>
                        <Button
                          type="primary"
                          className="btn-primary"
                          onClick={() =>
                            navigate("/infratech-marketplace/list")
                          }
                        >
                          VIEW MORE PRODUCTS
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </Fade>
        </div>
      )}
    </>
  );
};
